<template>
  <div :class="[containerclass, 'shadecolorpickercomponent']">
    <ul class="km__list--modules shade-colors"
        v-if="filteredShadeColors.length > 0">

      <li class="km__list__element--modules"
          v-for="(shadeColor) in filteredShadeColors"
          :key="shadeColor.NameImWeb"
          :class="isCurrentlyChosenColorshade(shadeColor.RGBHex) ? 'active':''"
      >
        <div class="km__button--color shade"
             :style="{ 'background-color': '#' + shadeColor.RGBHex }"
             :class="{activeShadeColor:isCurrentlyChosenColorshade(shadeColor.RGBHex), border:colorIsNearWhite(shadeColor.RGBHex)}"
             @click="$emit('setColor', shadeColor)"
        >
          {{ shadeColor.NameImWeb }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>

import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {computed, PropType, Ref, toRefs, watch} from "vue";
import {PalettenClusterSorted} from "@k/js/databaseInterfaceClasses";
import {KEYFRAMETARGETS} from "@km/animations/animationFactory";
import {ColorUtils} from "@k/js/colorUtils";
import gsap from "gsap";
import {useColoreditStore} from "@km/components/color/colorEditStatusStore";

class ModuleColorShadeFunctions {

  public static filteredShadeColors(
      palettenCluster: PalettenClusterSorted | null,
      currentColorValueIntOrNONEstring: string | number | null,
      currentPalette: string|null
  ) {
    if (palettenCluster === null || currentColorValueIntOrNONEstring === null || currentColorValueIntOrNONEstring === "<none>") {
      return [];
    }

    const colorPositionInfo = ColorUtilsVue.getColorPositionInfoForIntValue(
        currentColorValueIntOrNONEstring as string,
        palettenCluster, currentPalette as string
    );
    if (colorPositionInfo === null) {
      return [];
    }
    return palettenCluster![colorPositionInfo.palette][colorPositionInfo.gruppenIndex];
  }
}

const props = defineProps<{
  containerclass: string,
  palettenCluster: PalettenClusterSorted | null,
  currentColorValueIntOrNONEstring: string|number|null,
  hasNoColorOption?: string,
  animationkeyframesgetter: { getterForWatch, keyframes, animation: (keyframe: KEYFRAMETARGETS) => void },
  currentpalette: string|null|undefined
}>()



watch(props.animationkeyframesgetter!.getterForWatch, (newstate: KEYFRAMETARGETS) => {
  props.animationkeyframesgetter!.animation(props.animationkeyframesgetter!.keyframes.getTarget(newstate));
})

const filteredShadeColors = computed(() => {
      const out = parseInt(props.currentColorValueIntOrNONEstring as string) < 0 ?
          [] :
          ModuleColorShadeFunctions.filteredShadeColors(props.palettenCluster, props.currentColorValueIntOrNONEstring, props.currentpalette);
      if (out.length > 0 && props.animationkeyframesgetter!.getterForWatch() === KEYFRAMETARGETS.OPEN) {
        gsap.fromTo("." + [props.containerclass, 'shadecolorpickercomponent'].join("."), {
          y: 45,
          opacity: 0
        }, {duration: 0.5, y: 0, opacity: 1});
        gsap.fromTo("." + [props.containerclass, 'shadecolorpickercomponent'].join("."), {opacity: 0}, {
          duration: 1.0,
          opacity: 1
        });
      }
      return out;
    }
);


const isCurrentlyChosenColorshade = (rgbHexOrNoneString: string) => {
  if (props.currentColorValueIntOrNONEstring === "<none>") {
    return rgbHexOrNoneString === "<none>";
  }
  return ColorUtils.hexToDec(rgbHexOrNoneString) === parseInt(props.currentColorValueIntOrNONEstring as string)
};
const colorIsNearWhite = ColorUtilsVue.colorHexIsNearWhite

</script>


<style lang="scss" scoped>
.km__modules__color--shade, .shadecolorpickercomponent {
  position: fixed;
  overflow: hidden;
  bottom: calc(120px + #{$cta-height});
  left: 50%;
  width: 240px;
  margin-left: -120px;
  z-index: -9999;
  padding-bottom: 0;
  display: flex;
  justify-content: center;
  opacity: 0;

  .km__list--modules {
    display: flex;
    flex-direction: row;

    .km__list__element--modules {
      padding: 6px 7px;

      &.active {
        .km__button--color {
          &:after {
            content: '';
            position: absolute;
            top: -5px;
            left: -5px;
            width: calc(100% + 10px);
            height: calc(100% + 10px);
            border: 2px solid $color-blue;
          }
        }
      }
    }
  }
}

.shadecolorpickercomponent {
  background: transparent;
}

.km__modules__logo--color--shade {
  &.shadecolorpickercomponent {
    padding-top: 20px;
    width: 250px;
    margin-left: -125px;
  }
}
</style>
